import UI from "./elements.module"

class HeaderModule {
	private ui = new UI()

	constructor() {
	}

	private get currentPage() {
		return window.location.pathname;
	}


	private updateHeaderLogo() {
		const header = document.getElementById("header") as HTMLElement
		const headerContacts = document.querySelector(".contacts") as HTMLElement
		const headerContents = document.querySelector(".header-contents") as HTMLElement

		const phoneImgElement = document.querySelector('.phone > img') as HTMLImageElement
		const emailImgElement = document.querySelector('.email > img') as HTMLImageElement
		const pictureElement = document.querySelector('picture') as HTMLElement

		let sourceElement = document.querySelector('source[media="(min-width: 1280px)"]') as HTMLImageElement
		let sourceElement2 = document.querySelector('source[media="(min-width: 465px)"]') as HTMLImageElement
		let imgElement = document.querySelector('img') as HTMLImageElement
		
		const originalSourceElement = '/icons/justloos-logo-light.svg'
		const originalSourceElement2 = '/icons/justloos-logo-light-mobile.svg'
		const originalImgElement = '/icons/justloos-logo-light.svg'

		const newSourceElement = '/icons/justloos-logo.svg'
		const newSourceElement2 = '/icons/justloos-logo-mobile.svg'
		const newImgElement = '/icons/justloos-logo.svg'

		const phoneOriginalSourceElement = '/icons/phone-light.svg'
		const emailOriginalSourceElement = '/icons/email-light.svg'

		const phoneNewSourceElement = '/icons/phone.svg'
		const emailNewSourceElement = '/icons/email.svg'

		if (this.currentPage === '/') {
			if (header.hasAttribute('data-header-box-shadow') && header.hasAttribute('data-dark-header')) {
				sourceElement.srcset = newSourceElement
				sourceElement2.srcset = newSourceElement2
				imgElement.src = newImgElement
				phoneImgElement.src = phoneNewSourceElement
				emailImgElement.src = emailNewSourceElement
			} else {
				sourceElement.srcset = originalSourceElement
				sourceElement2.srcset = originalSourceElement2
				imgElement.src = originalImgElement
				phoneImgElement.src = phoneOriginalSourceElement
				emailImgElement.src = emailOriginalSourceElement
			}
		} else {
			header.removeAttribute('data-dark-header')
		}



	}

	addWatcherToHeaderOnScroll() {
		const scrollableWatcher = document.createElement("div")
		scrollableWatcher.setAttribute('data-observer-intercept', '')
		this.ui.header?.before(scrollableWatcher)
		this.ui.headerIntersect = document.querySelector("[data-observer-intercept]")
	}

	setHeaderShadow() {
		const onIntersect = (entries: IntersectionObserverEntry[]) => {
			entries.forEach(entry => {
				this.ui.header?.toggleAttribute("data-header-box-shadow", !entry.isIntersecting)
				this.ui.navBar?.toggleAttribute("data-header-box-shadow", !entry.isIntersecting)
				this.ui.header?.toggleAttribute("data-header-shrink", !entry.isIntersecting)
				if (this.currentPage === '/') {
					this.ui.header?.setAttribute('data-dark-header', !entry.isIntersecting ? 'false' : 'true')
					this.updateHeaderLogo()
				}
			});
		}

		const observer = new IntersectionObserver(onIntersect)
		observer.observe((this.ui.headerIntersect as HTMLElement))
	}

	setMainElementToMatchHeader() {
		const header = new ResizeObserver(entries => {

			for (let entry of entries) {
				const main = document.querySelector("main")
				main!.style.paddingBlockStart = `${entry.borderBoxSize[0].blockSize}px`
			}
		})

		header.observe((this.ui.header as HTMLElement))
	}

	addBoxShadowWhenNotPrimaryBg() {
		if (!this.ui.heroSection?.getAttribute('class')?.includes('bg-')) {
			if (this.ui.header) this.ui.header.style.boxShadow = 'var(--shadow-md)';
		}
	}

	headerHasBoxShadow() {
		const targetNode = document.getElementById("header") as HTMLElement
		const config = { attributes: true };
		const callback = (mutationsList: MutationRecord[], observer: MutationObserver) => {

			for (let mutation of mutationsList) {

				if (mutation.type === 'attributes' && mutation.attributeName === 'data-header-box-shadow') {
					this.updateHeaderLogo()
				}

			}
		}

		const observer = new MutationObserver(callback)
		observer.observe(targetNode, config)
		this.updateHeaderLogo()
	}
}

export default HeaderModule
